import Vue from "vue"
import Vuex from "vuex"
import api from "@/services/api"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    page: {},

    site_id: "pinders",
    settings: null,
    main_pages: null,
    prices_page: null,
    reviews_page: null,
    reviews: null,
    brochures: null,

    homeID: "sJNjbe0i4",
    reviewsID: "66R3lM0L3",
    pricesID: "909PGFfkL",
    galleryID: "Kl70C4ldA",
    contactID: "5v6hmtmhi",

    banner_loaded: false
  },
  getters: {
    isHomePage(state) {
      return state.page.ItemID && state.page.ItemID == state.homeID
    },
    isReviewsPage(state) {
      return state.page.ItemID && state.page.ItemID == state.reviewsID
    },
    isPricesPage(state) {
      return state.page.ItemID && state.page.ItemID == state.pricesID
    },
    isGalleryPage(state) {
      return state.page.ItemID && state.page.ItemID == state.galleryID
    },
    isContactPage(state) {
      return state.page.ItemID && state.page.ItemID == state.contactID
    },
    mainMenu(state) {
      if (!state.main_pages) return []
      return state.main_pages
    }
  },
  mutations: {
    setPage(state, page) {
      state.page = page
    },
    setPricesPage(state, page) {
      state.prices_page = page
    },
    setReviewsPage(state, page) {
      state.reviews_page = page
    },
    setSettings(state, settings) {
      state.settings = settings
    },
    setMainPages(state, main_pages) {
      state.main_pages = main_pages
    },
    setReviews(state, reviews) {
      state.reviews = reviews
    },
    setBrochures(state, brochures) {
      state.brochures = brochures
    },
    bannerLoaded(state, payload) {
      if (payload == 0) Vue.nextTick().then(() => (state.banner_loaded = true))
    }
  },
  actions: {
    getSettings({ commit, state }) {
      return new Promise(resolve => {
        if (!state.settings)
          api.getPageByItemID("SETTINGS").then(settings => {
            commit("setSettings", settings)
            resolve()
          })
        else resolve()
      })
    },
    getPricesPage({ commit, state }) {
      return new Promise(resolve => {
        if (!state.prices_page)
          api.getPageByItemID(state.pricesID).then(page => {
            commit("setPricesPage", page)
            resolve()
          })
        else resolve()
      })
    },
    getReviewsPage({ commit, state }) {
      return new Promise(resolve => {
        if (!state.reviews_page)
          api.getPageByItemID(state.reviewsID).then(page => {
            commit("setReviewsPage", page)
            resolve()
          })
        else resolve()
      })
    },
    getReviews({ commit, state }) {
      return new Promise(resolve => {
        if (!state.reviews)
          api.getPageByItemID("REVIEWS", "items").then(page => {
            commit("setReviews", page.items)
            resolve()
          })
        else resolve()
      })
    },
    getBrochures({ commit, state }) {
      return new Promise(resolve => {
        if (!state.brochures)
          api.getPageByItemID("BROCHURES", "items").then(page => {
            commit("setBrochures", page.items)
            resolve()
          })
        else resolve()
      })
    },
    getMainPages({ commit, state }) {
      return new Promise(resolve => {
        if (!state.main_pages)
          api.getPages("", "page.main").then(main_pages => {
            commit("setMainPages", main_pages)
            resolve()

            var promises = []

            main_pages.forEach(page => {
              promises.push(api.getPages("", "page.sub=@" + page.ItemID).then(subs => Vue.set(page, "subs", subs)))
            })

            Promise.all(promises).then(() => {
              commit("setMainPages", main_pages)
            })
          })
        else resolve()
      })
    }
  }
})
